<template>
  <div class="cn-subcategory-header">
    <div class="container">
      <div class="cn-subcategory-header__block">
        <div class="cn-subcategory-header__content">
          <h1 class="cn-subcategory-header__title">
            {{ title }}
          </h1>
          <CdnImg
            v-if="image"
            :src="image"
            format="webp"
            :width="300"
            :height="150"
          />
        </div>
        <UiParallelogram
          color="aqua"
          class="cn-subcategory-header__parallelogram-1"
        />
        <UiParallelogram
          color="aqua"
          class="cn-subcategory-header__parallelogram-2"
        />
        <UiParallelogram
          color="aqua"
          class="cn-subcategory-header__parallelogram-3"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { CdnImg } from '@webplatform/cdn-image';
import UiParallelogram from '@/components/ui/UiParallelogram';

interface Props {
  title?: string;
  image?: string;
}
defineProps<Props>();
</script>

<style lang="scss">
.cn-subcategory-header {
  --ab-canyon-subcategory-header-color-bg: var(--ab-canyon-color-primary);
  --ab-canyon-subcategory-header-title-color-text: var(--ab-canyon-color-light);

  background-color: var(--ab-canyon-subcategory-header-color-bg);
  display: flex;
  align-items: center;
  overflow: hidden;
  min-height: 100px;
  &__block {
    position: relative;
  }
  &__content {
    justify-content: space-between;
    flex-direction: column;
    display: flex;
    z-index: 10;
    position: relative;
    @media (min-width: 656px) {
      align-items: center;
      flex-direction: row;
    }

    img {
      @media (min-width: 1280px) {
        margin-right: calc(7 * var(--size-base));
      }
      @media (min-width: 1656px) {
        margin-right: calc(10 * var(--size-base));
      }
    }
  }
  &__title {
    color: var(--ab-canyon-subcategory-header-title-color-text);
    text-transform: uppercase;
    font-weight: 700;
    font-size: 1.25rem;
    line-height: 1.75rem;
    padding-top: var(--size-base);
    padding-bottom: var(--size-base);
    z-index: 10;
    position: relative;
    @media (min-width: 1656px) {
      font-size: 2.25rem;
      line-height: 2.5rem;
    }
    @media (min-width: 656px) {
      font-size: 1.875rem;
      line-height: 2.25rem;
    }
  }
  &__parallelogram-1 {
    transform: rotate(30deg) skewY(-30deg);
    width: 40px;
    height: 70px;
    left: -20px;
    bottom: -20px;
    position: absolute;
    @media (min-width: 656px) {
      border-width: 3px;
      top: 140px;
      left: 35%;
      bottom: auto;
    }
  }
  &__parallelogram-2 {
    transform: rotate(30deg) skewY(-30deg);
    width: 50px;
    height: 80px;
    top: 30%;
    right: 15px;
    position: absolute;
    @media (min-width: 656px) {
      width: 30px;
      height: 50px;
      top: 40px;
      right: auto;
      left: 42%;
    }
  }
  &__parallelogram-3 {
    transform: rotate(30deg) skewY(-30deg);
    width: 30px;
    height: 45px;
    display: none;
    top: 50px;
    right: 50px;
    position: absolute;
    @media (min-width: 656px) {
      display: block;
    }
  }
  .cn-parallelogram {
    border-width: 3px;
  }
}
</style>
